import { Button } from 'react-bootstrap';
import EToolTip from 'components/others/EToolTip';
import SolarIcon from 'components/icons/SolarIcon';

interface TaskFilterButtonProps {
    active: boolean;
    title: string;
    onOpen: () => void;
}

const TaskFilterButton = ({ active, title, onOpen }: TaskFilterButtonProps) => (
    <EToolTip title={title}>
        <span className="d-inline-block">
            <Button
                className="fs-14 px-2"
                size="sm"
                variant={active ? 'danger' : 'primary'}
                onClick={(e) => {
                    e.currentTarget.blur();
                    onOpen();
                }}
            >
                <SolarIcon name="funnel" className="fs-14 p-0" />
            </Button>
        </span>
    </EToolTip>
);

export default TaskFilterButton;
